export default __webpack_public_path__ + "static/media/hideMenuIconArrow.e98a48f0.svg";